export default {
  Btn_Common: {
    TuoZhuai: '拖拽',
    QueDing: '確定',
    QuXiao: '取消',
    XinZeng_ZhuanJieMa: '新增轉介碼',
    XiuGai_ZhuanJieMa: '修改轉介碼',
    XiuGai: '修改',
    Chufang_Yulan: '處方預覽',
    DengRu: '登入',
    ChaXun: '查詢',
    ChongZhi: '重置',
    XinZeng: '新增',
    FenPei_JueSe: '分配角色',
    PaiBan_HaoYuan: '排班號源',
    ChongZhi_MiMa: '重置密碼',
    QueRen: '確認',
    GuanBi: '關閉',
    FuZhi: '複製',
    FuZhi_QuanBu: '複製全部',
    ZhanTie: '粘貼',
    BaoCun: '保存',
    YiSheng_Duan: '醫生端',
    XiuGai_ZhangHao_MiMa: '修改賬號密碼',
    TuiChu_DengLu: '退出登錄',
    ShuaXin: '刷新',
    GuanBi_QiTa: '關閉其它',
    GuanBi_SuoYou: '關閉所有',
    XinZeng_JueSe: '新增角色',
    FenPei_QuanXian: '分配權限',
    ShanChu: '刪除',
    XiuGai_JueSe: '修改角色',
    XinZeng_YouHuiQuan: '新增優惠券',
    FaFang: '發放',
    PeiSong: '配送',
    TianJia_DiZhi: '添加地址',
    XiaZai: '下載',
    XinZeng_DingDan: '新增訂單',
    ShenPi: '審批',
    QianShou: '簽收',
    WanJie: '完結',
    QianShou_JiLu: '簽收記錄',
    ShenHe: '審核',
    XuanZe_YaoPin: '選擇藥品',
    QingKong_DingDan: '清空訂單',
    ZanCun: '暫存',
    TiJiao: '提交',
    Shang_Yi_Bu: '上一步',
    QingChu: '清除',
    ShangChuan: '上傳',
    YuLan: '預覽',
    YuLan_Hou_TiJiao: '預覽後提交',
    XiuGai_MiMa: '修改密碼',
    XuanZe_XueWei: '選擇穴位',
    XinZeng_YaoPin: '新增藥品',
    TongBu: '同步',
    ShouFei_ZongJie: '收費總結',
    TongBu_GengXin: '同步更新',
    XinZeng_ShangPin: '新增商品',
    XinZeng_BingRen: '新增病人',
    XinZeng_TaoPiao: '新增套票',
    TianRu: '填入',
    QuanBu_XuanZhong: '全部選中',
    QuXiao_XuanZhong: '取消選中',
    ShengCheng_HaoYuan: '生成號源',
    XinZeng_ZhenSuo: '新增診所',
    XiuGai_ZhenSuo: '修改診所',
    PeiZhi: '配置',
    SouXun: '搜尋',
    PiCi: '批次',
    XiuGai_YaoPin: '修改藥品',
    YaoPin: '藥品',
    WanCheng: '完成',
    TianJia_ZuiXinJiLu: '添加最新記錄',
    BianJi_ZuiJinJiLu: '編輯最近記錄',
  },
}
